import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = onClick ?? (() => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      const el = document.getElementById('oferta');
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
  return <button onClick={handleClick} className={`
        relative group overflow-hidden rounded-md font-heading font-bold text-lg md:text-xl
        bg-brand-gold text-brand-bg px-8 py-4 w-full md:w-auto
        transition-all duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(212,168,67,0.4)]
        ${className}
      `} data-id="element-108">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-109">
        {children}
      </span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-110" />
    </button>;
}